import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App.tsx';
import { bootstrapBrand } from './brand.ts';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// S4 4.W2 — resolve the org brand BEFORE first paint so a white-label
// org doesn't flash the default blue/Heebo theme. Capped at 1.2s so a slow or
// absent backend never blanks the screen: on timeout we paint with the
// built-in defaults and `bootstrapBrand` still applies the brand in place when
// /org-config later resolves (CSS vars cascade live). Wrapped in an async
// bootstrap (not top-level await) for build-target portability.
const start = async (): Promise<void> => {
  await Promise.race([
    bootstrapBrand(),
    new Promise<void>((resolve) => setTimeout(resolve, 1200)),
  ]);
  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );
};

void start();
